
import React from "react";
import { FiArrowRight } from "react-icons/fi";

const brands = [
  {
    name: "COUNTRY CLOUDS",
    style: "text-[13px] font-extrabold tracking-[-0.7px] sm:text-[15px]",
  },
  {
    name: "FRUITIA",
    style: "text-[22px] font-black tracking-[-1.2px] sm:text-[25px]",
  },
  {
    name: "BY THE POUND",
    style: "text-[13px] font-black tracking-[-0.8px] sm:text-[15px]",
  },
  {
    name: "LEMON LAW",
    style: "text-[16px] font-black tracking-[-0.8px] sm:text-[19px]",
  },
  {
    name: "TWISTED SOUR",
    style: "text-[13px] font-extrabold tracking-[-0.6px] sm:text-[15px]",
  },
  {
    name: "KANGERTECH",
    style: "text-[13px] font-black tracking-[-0.7px] sm:text-[15px]",
  },
  {
    name: "ELEAF",
    style: "text-[23px] font-black tracking-[1px] sm:text-[26px]",
  },
  {
    name: "VIHO",
    style: "text-[24px] font-black tracking-[-1px] sm:text-[28px]",
  },
  {
    name: "VIM",
    style: "text-[25px] font-black tracking-[-1px] sm:text-[29px]",
  },
  {
    name: "TWIST E-LIQUIDS",
    style: "text-[12px] font-extrabold tracking-[-0.5px] sm:text-[14px]",
  },
];

export default function FeaturedBrands() {
  return (
    <section className="w-full bg-[#fffdfb] px-4 py-4 sm:px-6 sm:py-8 lg:px-[4.3%] lg:py-9">
      <div className="mx-auto w-full max-w-[1500px]">
        {/* Section heading */}
        <div className="mb-4 flex items-center justify-between sm:mb-5">
          <h2 className="flex items-center gap-[9px] font-serif text-[20px] font-bold leading-none tracking-[-0.5px] text-[#17151b] sm:text-[22px]">
            <span className="h-[14px] w-[2px] rounded-full bg-[#7027df]" />
            Featured Brands
          </h2>

          <a
            href="/shop"
            className="flex shrink-0 items-center gap-2 text-[11px] font-semibold text-[#6b28d9] transition-colors hover:text-[#4818a8] sm:text-[12px]"
          >
            View All Brands
            <FiArrowRight size={15} />
          </a>
        </div>


{/* Brand strip */}
<div className="rounded-[15px] border border-[#f0e6f5] bg-gradient-to-r from-[#f7effa] via-[#f4edf9] to-[#f8effa] px-4 py-6 sm:px-5 lg:px-6">
  <div className="grid grid-cols-2 items-center gap-x-4 gap-y-6 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 lg:gap-x-5">
    {brands.map((brand) => (
      <a
        key={brand.name}
        href={`/brands/${brand.name
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "")}`}
        title={brand.name}
        className="flex min-h-[42px] min-w-0 items-center justify-center text-center text-[#211c29] transition-colors duration-200 hover:text-[#7027df]"
      >
        <span className={`${brand.style} whitespace-normal leading-tight`}>
          {brand.name}
        </span>
      </a>
    ))}
  </div>
</div>

      </div>
    </section>
  );
}
